import { http, HttpResponse } from "msw";

import { DEMO_PROJECT_REPO_NAME } from "@shared/constants";
import {
  SastProjectAnalyticsItem,
  SastProjectAnalyticsResponse,
} from "@shared/types";

import { TEST_ORG } from "./deployments";

export const DEMO_PROJECT_ITEM: SastProjectAnalyticsItem = {
  project_name: DEMO_PROJECT_REPO_NAME,
  open_findings_count: 1,
  severity_high_count: 1,
  fixed_findings_rate: 0.2,
  is_setup: true,
};

export const OLD_PROJECT_ITEM: SastProjectAnalyticsItem = {
  project_name: `${TEST_ORG.slug}/old-project`,
  open_findings_count: 1,
  severity_high_count: 1,
  fixed_findings_rate: 0.2,
  is_setup: true,
};

export const MONTH_OLD_PROJECT_ITEM: SastProjectAnalyticsItem = {
  project_name: `${TEST_ORG.slug}/one-month-old-project`,
  open_findings_count: 1,
  severity_high_count: 1,
  fixed_findings_rate: 0.2,
  is_setup: true,
};

export const NEW_PROJECT_ITEM: SastProjectAnalyticsItem = {
  project_name: `${TEST_ORG.slug}/new-project`,
  open_findings_count: 1,
  severity_high_count: 1,
  fixed_findings_rate: 0.2,
  is_setup: true,
};

export const LAST_DAY_PROJECT_STATS: SastProjectAnalyticsResponse = {
  project_analytics_items: [NEW_PROJECT_ITEM],
};

export const ONE_MONTH_PROJECT_STATS: SastProjectAnalyticsResponse = {
  project_analytics_items: [
    ...LAST_DAY_PROJECT_STATS.project_analytics_items,
    MONTH_OLD_PROJECT_ITEM,
  ],
};

export const ALL_TIME_PROJECT_STATS: SastProjectAnalyticsResponse = {
  project_analytics_items: [
    ...ONE_MONTH_PROJECT_STATS.project_analytics_items,
    OLD_PROJECT_ITEM,
  ],
};

export const analyticsHandlersStatic = [
  http.get("*/api/agent/deployments/:id/analytics/projects", ({ request }) => {
    const url = new URL(request.url);
    const since = url.searchParams.get("since");
    if (since === "0") {
      return HttpResponse.json(ALL_TIME_PROJECT_STATS, { status: 200 });
    }
    return HttpResponse.json(LAST_DAY_PROJECT_STATS, { status: 200 });
  }),
  http.get("*/api/agent/deployments/:id/analytics/rules", () =>
    HttpResponse.json(
      { rules: [], total_results_count: 0, event_type: "fired" },
      { status: 200 }
    )
  ),
  http.get("*/api/agent/deployments/:id/analytics/summary", () =>
    HttpResponse.json(
      {
        open_issues_count: 0,
        severity_high_count: 0,
        pr_fix_rate: 0,
        open_issues_delta: 0,
        severity_high_delta: 0,
        pr_fix_rate_delta: 0,
      },
      { status: 200 }
    )
  ),
];
